import React from 'react'

function HzDivider() {
    return (
        <div style={{height: '0.5px', width: '100%', backgroundColor: '#d2d2d7', padding: '0', margin: '0'}}></div>     
    )
}

export default HzDivider 